export const loading = (state) => state.loading;
export const receivedEmails = (state) => state.receivedEmails;
export const selectedEmail = (state) => state.selectedEmail;
export const showEmailViewer = (state) => state.showEmailViewer;
export const page = (state) => state.page;
export const pages = (state) => state.pages;
export const itemsPerPage = (state) => state.itemsPerPage;
export const getFilters = (state) => state.filters;
